import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-playlistlogout-modal',
  templateUrl: './playlistlogout-modal.component.html',
  styleUrls: ['./playlistlogout-modal.component.css']
})
export class PlaylistlogoutModalComponent {
  message: string = ''; 
  onClose: Subject<string> = new Subject();

  constructor(public bsRef: BsModalRef) {
    console.log(this.bsRef);
    
  }

  confirm() {
    this.onClose.next('yes');
    this.bsRef.hide();
  }

  decline() {
    this.onClose.next('no');
    this.bsRef.hide();
  }
  
}
